import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function getTenantType(user) {
  if (!user) return null;
  return user.tenant_Type || user.tenantType || user.userData?.tenant_Type || user.userData?.tenantType || null;
}

export default function RestaurantGuard({ children }) {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const tenantType = getTenantType(user);
  if (tenantType && tenantType !== 'restaurant') {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
